import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { DecisionWheel } from "../components/DecisionWheel";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.dw_tool_name()}
        toolPath="/decision-wheel"
      />
      <SciHeader title={m.dw_h1()} intro={m.dw_intro()} />
      <DecisionWheel />
      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.dw_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.dw_ex1(), m.dw_ex2(), m.dw_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.dw_faq_q1(), a: m.dw_faq_a1() },
          { q: m.dw_faq_q2(), a: m.dw_faq_a2() },
          { q: m.dw_faq_q3(), a: m.dw_faq_a3() },
          { q: m.dw_faq_q4(), a: m.dw_faq_a4() },
        ]}
      />
      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
